/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./lucky.vue?vue&type=template&id=1a5fe9d5&scoped=true"
import script from "./lucky.vue?vue&type=script&lang=js"
export * from "./lucky.vue?vue&type=script&lang=js"
import style0 from "./lucky.vue?vue&type=style&index=0&id=1a5fe9d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5fe9d5",
  null
  
)

export default component.exports